var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Proximo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_394_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_257_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    fill: "#54FEBD",
    width: 40,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_256_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 32,
    fill: "#54FEBD",
    width: 24,
    height: 12
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_255_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 48,
    fill: "#54FEBD",
    width: 10,
    height: 12
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1070_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M62.99951,6c-0.24268,0-0.48584-0.08789-0.67822-0.26563l-3.64941-3.37305l-3.65332,3.37305 c-0.38281,0.35352-0.97314,0.35352-1.35693,0l-3.65039-3.37305l-3.65332,3.37305c-0.38281,0.35352-0.97363,0.35352-1.35645,0 l-3.65479-3.37305l-3.65527,3.37305c-0.38281,0.35352-0.97363,0.35352-1.35645,0l-3.65479-3.37305l-3.65381,3.37305 c-0.38281,0.35352-0.97363,0.35352-1.35645,0l-3.65527-3.37402l-3.65771,3.375c-0.38379,0.35352-0.97314,0.35352-1.35596,0 l-3.66162-3.375l-3.66162,3.375c-0.40771,0.37305-1.04004,0.34766-1.41309-0.05762 c-0.37402-0.40625-0.34863-1.03906,0.05762-1.41309l4.33936-4c0.38281-0.35352,0.97266-0.35352,1.35547,0l3.66162,3.375 l3.6582-3.375c0.38428-0.35352,0.97412-0.35254,1.35645,0.00098l3.65479,3.37305l3.65381-3.37305 c0.38281-0.35352,0.97363-0.35352,1.35645,0l3.65479,3.37305l3.65527-3.37305c0.38281-0.35352,0.97363-0.35352,1.35645,0 l3.65479,3.37305l3.65332-3.37305c0.38281-0.35352,0.97314-0.35352,1.35693,0l3.65039,3.37305l3.65381-3.37305 c0.3833-0.35352,0.97461-0.35352,1.35693,0l4.32764,4c0.40576,0.375,0.43066,1.00781,0.05566,1.41309 C63.53711,5.8916,63.26904,6,62.99951,6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1069_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M58,64H6c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h52c2.20557,0,4-1.79395,4-4V5c0-0.55273,0.44775-1,1-1 s1,0.44727,1,1v53C64,61.30859,61.30859,64,58,64z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1068_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M6,64c-3.30859,0-6-2.69141-6-6V3c0-0.55273,0.44775-1,1-1s1,0.44727,1,1v55c0,2.20605,1.79443,4,4,4 s4-1.79395,4-4V5c0-0.55273,0.44775-1,1-1s1,0.44727,1,1v53C12,61.30859,9.30859,64,6,64z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1067_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M7,4H1C0.44775,4,0,3.55273,0,3s0.44775-1,1-1h6c0.55225,0,1,0.44727,1,1S7.55225,4,7,4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1066_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M6,60c-0.55225,0-1-0.44727-1-1V7c0-0.55273,0.44775-1,1-1s1,0.44727,1,1v52C7,59.55273,6.55225,60,6,60z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1065_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M57,18H17c-0.55225,0-1-0.44727-1-1v-6c0-0.55273,0.44775-1,1-1h40c0.55225,0,1,0.44727,1,1v6 C58,17.55273,57.55225,18,57,18z M18,16h38v-4H18V16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1064_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M29,30H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h12c0.55225,0,1,0.44727,1,1S29.55225,30,29,30z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1058_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M29,34H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h12c0.55225,0,1,0.44727,1,1S29.55225,34,29,34z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1057_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M29,38H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h12c0.55225,0,1,0.44727,1,1S29.55225,38,29,38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1056_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M29,42H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h12c0.55225,0,1,0.44727,1,1S29.55225,42,29,42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1055_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M43,46H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h26c0.55225,0,1,0.44727,1,1S43.55225,46,43,46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1054_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M43,50H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h26c0.55225,0,1,0.44727,1,1S43.55225,50,43,50z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1053_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M43,54H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h26c0.55225,0,1,0.44727,1,1S43.55225,54,43,54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1052_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M43,58H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h26c0.55225,0,1,0.44727,1,1S43.55225,58,43,58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1051_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M57,22H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h40c0.55225,0,1,0.44727,1,1S57.55225,22,57,22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1050_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M57,42H33c-0.55225,0-1-0.44727-1-1V29c0-0.55273,0.44775-1,1-1h24c0.55225,0,1,0.44727,1,1v12 C58,41.55273,57.55225,42,57,42z M34,40h22V30H34V40z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1049_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M57,58H47c-0.55225,0-1-0.44727-1-1V45c0-0.55273,0.44775-1,1-1h10c0.55225,0,1,0.44727,1,1v12 C58,57.55273,57.55225,58,57,58z M48,56h8V46h-8V56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1048_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M57,26H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h40c0.55225,0,1,0.44727,1,1S57.55225,26,57,26z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.81cac42be798f4eecd89ea59428c0e2a.svg";
export { ForwardRef as ReactComponent };